import { Certification } from "./Certification";

export class TrainingAttestation {
    constructor(physicianId: number, trainingProgramId: number, trainingProgramTypeId: number, completedDate: string) {
        this.physicianId = physicianId;
        this.trainingProgramId = trainingProgramId;
        this.trainingProgramTypeId = trainingProgramTypeId;
        this.completedDate = completedDate;
    }
    
    trainingAttestationId: number;
    physicianId: number;
    trainingProgramId: number;
    trainingProgramTypeId: number;
    trainingProgramName: string;
    trainingProgramCode: string;
    completedDate: string;
    attestedDate: string;
    attestedBy: string;
    firstName: string;
    lastName : string;
    isPatientSafetyCompleted: boolean;
    isAttestedComplete: boolean;
    isPsychFastTrack: boolean;
    certifications: Array<Certification>;
}